import { JSX } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@heroui/react';

import { Feedback } from '~/components/Feedback';
import { Logo } from '~/components/Logo';

export function NotFound(): JSX.Element {
  return (
    <div className="h-screen flex flex-col items-center p-8">
      <Logo />
      <Feedback className="mt-[30vh]" type="not-found">
        <Button as={Link} to="/" color="primary">
          Go to Home
        </Button>
      </Feedback>
    </div>
  );
}
